module.exports = __webpack_public_path__ + "static/media/neutral_slightly-sad.9a128747.svg";